import { calculateTrendSummerMonths, getRechartsTrendObjects } from "./trend";

export default function getIncludedYears(period: string) {
    switch (period) {
        case "2016_2020":
            return ["2016", "2017", "2018", "2019", "2020"]
        case "2020_2021":
            return ["2020", "2021"]
        case "2021_2022":
            return ["2021", "2022"]
        case "2022_2023":
            return ["2022", "2023"]
        case "2023_2024":
            return ["2023", "2024"]
        case "2024_2025":
            return ["2024", "2025"]

        default:
            console.log("Err: Period does not exist yet")
            break;
    }
}



function normalize(min: number, max: number): (val: number) => number {
    var delta = max - min;
    return function (val: number) {
        return (val - min) / delta;
    };
}


export function createScatterChartArray(index: string, dashboardData: any, layerSelection: any) {
     /**
         * Filter all data where the key withholds the string "NDVI" or "NDWI" by looping through the dashboardData dictionary and create two seperate dicts.
         * Extract the date which is inside the key.
         * The date is in the format "YYMM".
         * Convert the date to the Date format.
         * Create a new array with dictionaries containing the date with the key date and the with the key value.
         * Set the state of the ndviData to the new array.
         */
        
    let outputArray: any = []

    for (const [key, value] of Object.entries(dashboardData)) {
        if (key.includes(index)) {
            let date = key.split("_")[1]
            let year = date.substring(0, 2)
            let month = date.substring(2, 4)
            let dateObject = new Date(parseInt("20" + year), parseInt(month))
            outputArray.push({ date: dateObject.getTime(), value: value })
        }
    }


    // Exclude all dictonaries in ndviDataArray where the date is not in includedYears
    // Check if included years not undefined
    const includedYears = getIncludedYears(layerSelection.period)
    if (includedYears != undefined) {
        outputArray = outputArray.filter((data: any) => {
            let date = new Date(data.date)
            return includedYears.includes(date.getFullYear().toString())
        })
    }
    let trendSlopeNormalized = 50
    // create trend
    if (outputArray.length != 0) {
        // Create two arrays with the dates and the values seperated
        let dates = outputArray.map((data: any) => new Date(data.date))
        let values = outputArray.map((data: any) => data.value)

        // Add trendline points only if dates and values are not empty
        const { minPoint, maxPoint } = getRechartsTrendObjects(dates, values)
        outputArray.push(minPoint)
        outputArray.push(maxPoint)

        // set trendValues to the calculated trend slope
        const trendSlope = calculateTrendSummerMonths(dates, Object.values(values)).equation[0]
        // Normalize the trend slope to the scale of 3 to 103 for Graphic
        trendSlopeNormalized = normalize(-0.02, 0.02)(trendSlope) * 100
        if (trendSlopeNormalized > 103) { trendSlopeNormalized = 103 }
        if (trendSlopeNormalized < 3) { trendSlopeNormalized = 3 }


    }
    return { outputArray, trendSlopeNormalized }
}